package ui.settings

import core.config.FeatureConfig

enum class SettingsNavItem(
    val title: String,
    val isEnabled: () -> Boolean = { true },
) {
    ImageGallery("Image gallery"),
    CategoriesTags("Categories & Tags"),
    AreasCountries("Areas & Countries"),
    DateTime("Date & Time"),
    Currency("Currency"),
    Payments(
        title = "Payments",
        isEnabled = { FeatureConfig.hasQuickBooks },
    ),
    General("General"),
    Backoffice("Backoffice")
}

fun getSettingsNavSidebarItems(): List<SettingsNavItem> {
    return SettingsNavItem.entries.filter { it.isEnabled() }
}